import { useSelector } from 'react-redux'

import CreditsLightningIcon from 'assets/svgr-icons/CreditsLightningPink.svg'
import { T } from 'consts/translationKeys'
import { creditsSelectors } from 'store/features/credits/selectors'
import { translate } from 'utils/translations'
import * as Styled from './styled'
import { useOpenUpgradePopup } from 'hooks/useOpenUpgradePopup'
import { REF_LINKS } from 'consts/refLinks'

const RefillButton = () => {
  const userCredits = useSelector(creditsSelectors.userCredits)
  const openUpgradePopup = useOpenUpgradePopup()

  return (
    <Styled.RefillButton
      onClick={() =>
        openUpgradePopup({ ref: REF_LINKS.V_EDITOR_HEADER_BUTTON })
      }
    >
      <CreditsLightningIcon />
      <Styled.CreditsCount>{userCredits}</Styled.CreditsCount>
      {userCredits === 0 && (
        <Styled.CreditsLabel>{translate(T.REFILL_LABEL)}</Styled.CreditsLabel>
      )}
    </Styled.RefillButton>
  )
}

export default RefillButton
